/* @flow */

export const BASE_SDK_METRIC_NAMESPACE = "pp.sdks.ppcp";

export const payPalWebV5Dimensions = {
  sdk_platform: "web",
  major_version: "5",
};
